import React, { FC, ReactElement } from "react";
import Spinner from "../Loading/Spinner";
// import Logo from "../../assets/logo.jpeg";
const AppLoading: FC = (): ReactElement => {
  /* function body */
  return (
    <div className="fixed top-0 bottom-0 flex right-0 left-0 items-center  justify-center">
      <div className="text-center animate__animated animate__fadeIn">
        <Spinner big={true} />
        <h1 className="mb-4 mt-2 text-2xl font-bold text-green-600">
          Deaf Action Rwanda
        </h1>
        {/* <img src={Logo} className="w-32 inline-block mt-5" alt="" /> */}
      </div>
    </div>
  );
};
export default AppLoading;
